/* eslint-disable */

/*
  https://github.com/jameslnewell/styled-components-breakpoint/blob/master/src/index.js
  Original version: 1.0.1
  Commit hash: 6dfa336
  Date: 3 Oct 2017
  Edited: defaultBreakpoints
*/

import { css } from 'styled-components'
import { DEFAULT_BREAKPOINTS } from 'src/utils/env'

/**
 * @param   {string}    name
 * @param   {object}    [breakpoints]
 * @returns {*}
 */
const breakpoint = (name, breakpoints = DEFAULT_BREAKPOINTS) => {
  let breakpoint = breakpoints[name];

  if (typeof breakpoint === 'number') {
    breakpoint = `${breakpoint}px`; //assume number is px and convert to 'em's
  }

  //special case for 0 to avoid wrapping in an unnecessary @media
  if (parseInt(breakpoint, 10) === 0) {
    // @ts-ignore
    return (...args) => css(...args)
  }

  return (...args) => css`
    @media (min-width: ${breakpoint}) {
      ${
        // @ts-ignore
        css(...args)
      }
    }
  `;
};

/**
 * @param   {*|object}  value
 * @param   {function}  mapValueToCSS
 * @param   {object}    [breakpoints]
 * @returns {*}
 */
export const map = (value, mapValueToCSS, breakpoints) => {
  const type = typeof value;

  if (type === 'object') {
    return [
      mapValueToCSS(undefined), //set the default value
      ...Object.keys(value).map(key => breakpoint(key, breakpoints)(...mapValueToCSS(value[key])))
    ];
  } else {
    return mapValueToCSS(value);
  }

};

export default breakpoint;
